import React, { useState, useEffect } from "react";
import styles from "./About.module.css";
import { AboutService } from "../../services/about_service";
import config from "../../config/config";
import { MissionVisionService } from "../../services/mission_vision_service";
import { AchievementService } from "../../services/achievement_service";
import Subscription from "../../pages/Subscription/Subscription";
import { FaInfoCircle } from "react-icons/fa";
import awards from "./awards.jpg"
import about from "./about.jpg"
const About = () => {
  const aboutService = AboutService();
  const missionVisionService = MissionVisionService();
  const achievementService = AchievementService();
  const [aboutData, setAboutData] = useState([]);
  const [missionVisionData, setMissionVisionData] = useState([]);
  const [achievementData, setAchievementData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        await aboutService.fetchAbout(setAboutData);
      } catch (error) {
        console.error("Error fetching data : ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();
  }, []);

  useEffect(() => {
    const fetchMissionVisionData = async () => {
      try {
        await missionVisionService.fetchMissionVision(setMissionVisionData);
      } catch (error) {
        console.error("Error fetching data : ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMissionVisionData();
  }, []);

  useEffect(() => {
    const fetchAchievementData = async () => {
      try {
        await achievementService.fetchAchievement(setAchievementData);
      } catch (error) {
        console.error("Error fetching data : ", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAchievementData();
  }, []);

  const getFullImageUrl = (iconPath) => {
    if (!iconPath) return awards;
    if (iconPath.startsWith("http")) return iconPath;
    return `${config.baseURL}${iconPath}`;
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
        <p>Loading about page...</p>
      </div>
    );
  }

  return (
    <div className={styles.aboutPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBg}><img src={about} alt="About Us" /></div>
        <div className={styles.heroOverlay}></div>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            {aboutData.badge && (
              <span className={styles.heroBadge}>{aboutData.badge}</span>
            )}
            <h1 className={styles.heroTitle}>
              {aboutData.title ? (
                <span dangerouslySetInnerHTML={{ __html: aboutData.title }} />
              ) : (
                <>
                  The <span>Royal Stage</span> of Sporting Excellence
                </>
              )}
            </h1>
            <p className={styles.heroSubtitle}>{aboutData.subtitle}</p>

            <div className={styles.heroStats}>
              <div className={styles.statItem}>
                <div className={styles.statNumber}>{aboutData.teams_count ? aboutData.teams_count : 0}</div>
                <div className={styles.statLabel}>Teams</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {aboutData.players_count ? aboutData.players_count : 0}
                </div>
                <div className={styles.statLabel}>Players</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>{aboutData.years_count ? aboutData.years_count : 0}</div>
                <div className={styles.statLabel}>Years</div>
              </div>

              <div className={styles.statItem}>
                <div className={styles.statNumber}>
                  {aboutData.matches_count ? aboutData.matches_count : 0}
                </div>
                <div className={styles.statLabel}>Matches</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {aboutData && aboutData.story_title && aboutData.story_description ? (
        <section className={`${styles.aboutContentSection} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>
                {aboutData.story_title}
              </h2>
            </div>

            <div className={styles.aboutContent}>
              {aboutData.image && (
                <img
                  src={getFullImageUrl(aboutData.image)}
                  alt={aboutData.title}
                  className={styles.aboutImage}

                />
              )}

              <div
                className={styles.description}
                dangerouslySetInnerHTML={{
                  __html: aboutData.story_description,
                }}
              />
            </div>
          </div>
        </section>
      ) : (
        <div className={styles.noDataWrapper}>
          <div className={styles.noData}>
            <div className={styles.noDataIcon}><FaInfoCircle /></div>
            <h3>No About Information Found</h3>
          </div>
        </div>
      )}
      {missionVisionData && (missionVisionData.mission_title || missionVisionData.vision_title || missionVisionData.values_title) && (
          <section className={`${styles.missionSection} ${styles.section}`}>
            <div className={styles.container}>
              <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Mission & Vision</h2>
              </div>

              <div className={styles.missionGrid}>
                {/* Mission */}
                {(missionVisionData.mission ||
                  missionVisionData.mission_title ||
                  missionVisionData.mission_content) && (
                    <div className={styles.missionCard}>
                      <div className={styles.missionIcon}>
                        <img
                          src={getFullImageUrl(missionVisionData.mission)}
                          alt="Mission"
                          height={50}
                          width={50}
                        />
                      </div>
                      <h3 className={styles.missionTitle}>
                        {missionVisionData.mission_title}
                      </h3>
                      <p
                        className={styles.missionText}
                        dangerouslySetInnerHTML={{
                          __html: missionVisionData.mission_content,
                        }}
                      />
                    </div>
                  )}

                {/* Vision */}
                {(missionVisionData.vision ||
                  missionVisionData.vision_title ||
                  missionVisionData.vision_content) && (
                    <div className={styles.missionCard}>
                      <div className={styles.missionIcon}>
                        <img
                          src={getFullImageUrl(missionVisionData.vision)}
                          alt="Vision"
                          height={50}
                          width={50}
                        />
                      </div>
                      <h3 className={styles.missionTitle}>
                        {missionVisionData.vision_title}
                      </h3>
                      <p
                        className={styles.missionText}
                        dangerouslySetInnerHTML={{
                          __html: missionVisionData.vision_content,
                        }}
                      />
                    </div>
                  )}

                {/* Values */}
                {(missionVisionData.value ||
                  missionVisionData.values_title ||
                  missionVisionData.values_content) && (
                    <div className={styles.missionCard}>
                      <div className={styles.missionIcon}>
                        <img
                          src={getFullImageUrl(missionVisionData.value)}
                          alt="Values"
                          height={50}
                          width={50}
                        />
                      </div>
                      <h3 className={styles.missionTitle}>
                        {missionVisionData.values_title}
                      </h3>
                      <p
                        className={styles.missionText}
                        dangerouslySetInnerHTML={{
                          __html: missionVisionData.values_content,
                        }}
                      />
                    </div>
                  )}
              </div>
            </div>
          </section>
        )
      }

      {achievementData.length > 0 && (
        <section className={`${styles.achievementsSection} ${styles.section}`}>
          <div className={styles.container}>
            <div className={styles.sectionHeader}>
              <h2 className={styles.sectionTitle}>League Achievements</h2>
            </div>
            <div className={styles.achievementsGrid}>
              {achievementData.map((achievement, index) => (
                <div key={index} className={styles.achievementCard}>

                  <img src={getFullImageUrl(achievement.icon)} alt="icon" className={styles.achievementIcon} height={50} width={50} />
                  <div className={styles.achievementContent}>
                    <h3>{achievement.title}</h3>
                    <p>{achievement.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
      {/* CTA Section */}
      <Subscription />
    </div>
  );
};

export default About;
